import * as React from 'react';
import { Spinner, Intent, Button, H4, Tooltip } from '@blueprintjs/core';
import { UserState } from 'app/reducers/state';
import { executeQueryPostAuth, executeQueryGetAuth, API_CHARTBACK } from 'app/utils/api';
import { KryPlayDetails } from 'app/components/KryPlayDetails';
import { isEqual, clone } from 'lodash';
import * as superagent from 'superagent';

import Highcharts from 'highcharts';
// import ReactHighcharts from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';
import hcXrange from 'highcharts/modules/xrange';
import { LoadableSVG } from 'app/components/LoadableSVG';
import { translateKey } from 'app/utils/forms';
import TextAreaV2 from 'app/components/TextAreaV2';

highchartsMore(Highcharts);
(hcXrange)(Highcharts)

const buttonTopOffset = "-15px";
interface Props {
    objectiveData?: any;
    gameID: string;
    user: UserState;
    needsJournal: boolean;
    journalData?: string;
    blocksObjectives: boolean;
    prompt: string;
    menuConfig?: any;
    startingJournalValue?: string;
    onResume: () => void;
    onSaveJournal: (preFeedback: string) => void;
};

interface State {
    loadingObjectiveData: boolean;
    objectiveData: any;
    writtenJouranl: string;
    savingJournal: boolean;
    loadingCharts: boolean;
    chartData: any;
    opinionTooltips: any;
    tensionTooltips: any;
    viewGraphic: boolean;
    viewSub1: boolean;
    viewSub2: boolean;
    viewSub3: boolean;
}

export class PauseScreen extends React.Component<Props, State> {

    state: State = {
        loadingObjectiveData: true,
        objectiveData: {},
        writtenJouranl: '',
        savingJournal: false,
        viewSub1: false,
        viewSub2: false,
        viewSub3: false,
        viewGraphic: true,
        loadingCharts: true,
        chartData: [],
        opinionTooltips: {},
        tensionTooltips: {}
    }

    getChartData = () => {

        const {
            opinionTooltips,
            tensionTooltips
        } = this.state;

        // Inject style settings
        let dataClone = clone(this.state.chartData);

        if (dataClone['chart'] === undefined) {
            dataClone['chart'] = {};
        }

        // Inject a full page height to our results chart
        dataClone['chart']['height'] = '550px';

        dataClone['tooltip'] = {
            formatter: function () {
                const round = this.x;
                const roundedY = Math.round(parseFloat(this.y));

                // Opinion
                if (this.color.toLowerCase() === '#00CB00'.toLowerCase()) {
                    return opinionTooltips[round.toString()];
                }

                // Tension
                if (this.color.toLowerCase() === '#FF9319'.toLowerCase()) {
                    return tensionTooltips[round.toString()];
                }

                // PI
                if (this.color.toLowerCase() === '#935730'.toLowerCase()) {
                    return '<b>Influence: ' + roundedY.toString() + '</b>';
                }

                return undefined;
            }
        }

        return dataClone;
    }

    componentDidMount() {
        this.setState({
            loadingObjectiveData: true
        });

        if (this.props.startingJournalValue !== undefined) {
            this.setState({
                writtenJouranl: this.props.startingJournalValue
            });
        }

        if (this.props.user.classicMode === 2) {
            superagent.
                get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&gameID=' + this.props.gameID).
                end((error:any, response:any) => {
                    const resp = JSON.parse(response.text);

                    if (resp === undefined) {
                        this.setState({
                            loadingCharts: false,
                            chartData: {},
                            opinionTooltips: {},
                            tensionTooltips: {}
                        });
                    }
                    else {
                        this.setState({
                            loadingCharts: false,
                            chartData: resp.chart,
                            opinionTooltips: resp.opinionTooltips,
                            tensionTooltips: resp.tensionTooltips
                        });
                    }
                }); 
        }
        else {
            executeQueryPostAuth("data/results/" + this.props.gameID, {}, this.props.user, (postResponse) => {
                executeQueryGetAuth("data/results/" + this.props.gameID, {}, this.props.user, (objectiveResponse) => {
                    const response = JSON.parse(objectiveResponse.text);
    
                    this.setState({
                        loadingObjectiveData: false,
                        objectiveData: response
                    });
                });
            });
        }
    }

    componentDidUpdate() {
        if (this.props.objectiveData !== undefined) {
            if (isEqual(this.props.objectiveData, this.state.objectiveData) === false) {
                this.setState({
                    objectiveData: this.props.objectiveData
                });
            }
        }
    }

    getCurrentRound = () => {
        const {
            objectiveData
        } = this.state;

        return parseInt(objectiveData['total-rounds']);
    }

    getJournalWarning = () => {
        const {
            writtenJouranl
        } = this.state;

        const {
            journalData
        } = this.props;

        if (journalData !== undefined && journalData !== '') {
            return undefined;
        }

        const wordCount = writtenJouranl.split(' ').length;

        if (wordCount > 10) return undefined;

        return 'You might want to write a more detailed plan.';
    }

    renderJournal = () => {
        const {
            savingJournal
        } = this.state;

        const {
            journalData,
            prompt
        } = this.props;

        if (savingJournal) {
            return <span>
                <Spinner />
            </span>
        }

        if (journalData !== undefined && journalData !== '') {
            return <span>
                <H4>{prompt}:</H4>
                <p style={{width: '100%', height: '200px'}}>
                    {journalData}
                </p>
            </span>
        }

        return <span>
            <H4>{prompt}:</H4>
            <TextAreaV2 value={this.state.writtenJouranl} onChange={(event) => {
                this.setState({
                    writtenJouranl: event.target.value
                });
            }} readOnly={this.getCurrentRound() > 1} className={"journalTextArea"} rows={15} style={{width: '100%', height: '200px'}}></TextAreaV2>
        </span>
    }

    handleResumeButtonPress = () => {
        const {
            onResume,
            needsJournal,
            onSaveJournal,
            journalData
        } = this.props;

        const {
            writtenJouranl
        } = this.state;

        if (needsJournal === false) {
            onResume();
            return;
        }

        // Don't save data if it's given journal data
        if (journalData !== undefined && journalData !== '') {
            onResume();
            return;
        }

        onSaveJournal(writtenJouranl);
    }

    renderClassicResumeButton = () => {
        const {
            needsJournal,
            journalData
        } = this.props;

        const {
            writtenJouranl
        } = this.state;

        if (needsJournal === false) {
            return <Button onClick={this.handleResumeButtonPress} style={{ lineHeight: '50px', width: '100px', height: '50px', paddingLeft: '10px' }} intent={Intent.SUCCESS}>Resume</Button>
        }

        const journalWarning = this.getJournalWarning();

        let isButtonDisabled = writtenJouranl === '';

        if (journalData !== undefined && journalData !== '') {
            isButtonDisabled = false;
        }

        return <Tooltip content={journalWarning}>
            <Button disabled={isButtonDisabled} onClick={this.handleResumeButtonPress} style={{ lineHeight: '50px', width: '100px', height: '50px', paddingLeft: '10px' }} intent={Intent.SUCCESS}>Resume</Button>
        </Tooltip>
    }

    renderResumeButton = () => {
        const {
            needsJournal,
            journalData
        } = this.props;

        const {
            writtenJouranl
        } = this.state;

        if (needsJournal === false) {
            return <Button onClick={this.handleResumeButtonPress} style={{width: '100%'}} large intent={Intent.SUCCESS}>Resume</Button>
        }

        const journalWarning = this.getJournalWarning();

        let isButtonDisabled = writtenJouranl === '';

        if (journalData !== undefined && journalData !== '') {
            isButtonDisabled = false;
        }

        return <Tooltip content={journalWarning}>
            <Button disabled={isButtonDisabled} onClick={this.handleResumeButtonPress} style={{width: '100%'}} large intent={Intent.SUCCESS}>Resume</Button>
        </Tooltip>
    }

    renderPlayDetails = () => {
        const {
            blocksObjectives
        } = this.props;

        const {
            objectiveData
        } = this.state;

        if (blocksObjectives === true) {
            return <span></span>
        }

        return <KryPlayDetails 
            user={this.props.user}
            selectedGame={objectiveData}
            canEditJournal={false}
            inSimulator={true}
            updateJournalDataInline={(stage: string, payload: string, gameID: string) => {
                // ignore this, we aren't letting them edit in this mode
            }}
        />
    }

    renderGraphicButton = () => {
        return <span style={{ position: 'relative', top: this.state.viewGraphic ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: true, viewSub2: false, viewSub1: false, viewSub3: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.reviewLesson')}</Button>
        </span>
    }

    renderGraphic1Button = () => {
        return <span style={{ position: 'relative', top: this.state.viewSub1 ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: false, viewSub2: false, viewSub1: true, viewSub3: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.businessResults')}</Button>
        </span>
    }

    renderGraphic2Button = () => {
        return <span style={{ position: 'relative', top: this.state.viewSub2 ? buttonTopOffset : undefined, marginRight: '5px' }}>
            <Button onClick={() => { this.setState({ viewGraphic: false, viewSub2: true, viewSub1: false, viewSub3: false }) }} style={{ lineHeight: '50px', width: '200px', height: '50px' }} intent={Intent.PRIMARY}>{translateKey('vleader.commitmentScoring')}</Button>
        </span>
    }

    renderCurrentClassicGraphic = () => {
        const {
            menuConfig
        } = this.props;

        const {
            viewGraphic,
            viewSub1,
            viewSub2,
        } = this.state;

        const currentGameMenuConfig = menuConfig

        //@ts-ignore
        const journalGraphic = currentGameMenuConfig ? currentGameMenuConfig!.journalGraphic : '';
        //@ts-ignore
        const journalAudio = currentGameMenuConfig ? currentGameMenuConfig!.journalAudio : '';
        //@ts-ignore
        const journalGraphicSub1 = currentGameMenuConfig ? currentGameMenuConfig!.journalGraphicSub1 : '';
        //@ts-ignore
        const journalGraphicSub2 = currentGameMenuConfig ? currentGameMenuConfig!.journalGraphicSub2 : '';
        //@ts-ignore
        const journalGrphicPost = currentGameMenuConfig ? currentGameMenuConfig!.journalGrphicPost : '';

        if (viewGraphic) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <LoadableSVG imgURL={journalGraphic} />
            </span>
        }

        if (viewSub1) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <LoadableSVG imgURL={journalGraphicSub1} />
            </span>
        }

        if (viewSub2) {
            return <span style={{ flexGrow: 1, flexBasis: 0 }}>
                <LoadableSVG imgURL={journalGraphicSub2} />
            </span>
        }

        return undefined;
    }

    renderControlRegion = () => {
        const mainControlButtons = [
            this.renderGraphicButton(),
            this.renderGraphic1Button(),
            this.renderGraphic2Button(),
            this.renderResumeButton()
        ]

        return <span style={{ width: '100%' }}>
            <span style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', float: 'right' }}>
                {mainControlButtons}
            </span>
        </span>
    }

    // If specified fallback to "classic" mode
    renderClassicMode = () => {
        const {
            loadingCharts
        } = this.state;

        if (loadingCharts) return <span style={{display: 'block', width: '100%', height: '100%'}}>
            <span style={{display: 'block', width: '200px', height: '300px', margin: 'auto', marginTop: '100px'}}>
                <H4 style={{textAlign: 'center', marginBottom: '40px'}}>Please Wait...</H4>
                <Spinner />
            </span>
        </span>

        //const chartData = this.getChartData();

        return <span className="playDetails" style={{position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', height: '90%', marginTop: '20px'}}>
            {this.renderControlRegion()}
            <span style={{ display: 'flex', flexDirection: 'column', height: '100%', flexWrap: 'wrap' }}>
                {this.renderCurrentClassicGraphic()}
            </span>
            <div className="clearfix" />
        </span>
    }

	render() {

        const {
            user
        } = this.props;

        if (user.classicMode === 2) {
            return this.renderClassicMode();
        }

        const {
            loadingObjectiveData,
        } = this.state;

        if (loadingObjectiveData) return <span style={{display: 'block', width: '100%', height: '100%'}}>
            <span style={{display: 'block', width: '200px', height: '300px', margin: 'auto', marginTop: '100px'}}>
                <H4 style={{textAlign: 'center', marginBottom: '40px'}}>Please Wait...</H4>
                <Spinner />
            </span>
        </span>

        return <span className="playDetails" style={{position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', height: '90%', marginTop: '20px'}}>
            <span className="playDetailsInnerTop">
                {this.renderPlayDetails()}
            </span>
            <span className="playDetailsInnerBottom">
                {this.renderJournal()}
                <span style={{display: 'block', marginTop: '20px'}}>
                    {this.renderResumeButton()}
                </span>
            </span>
            <div className="clearfix" />
        </span>
    }
}
